import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { UserStatus } from '@/types/all-attendees.types';

export const setAllAttendeesStatus = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<UserStatus | undefined>((state, action) => {
    state.allAttendees.status = action.payload;
    state.allAttendees.page = 1;
  });
